export const getLowercaseValue = (facility) => {
    if (isNaN(facility)) {
        return facility.toLowerCase()
    } else {
    return facility
    }
}